@if (lesson() && lesson()?.activity && lesson()?.activity!.length > 0) {
	<div>
		<app-carousel-title>{{ lesson()?.active_text?.name }}</app-carousel-title>
		<app-carousel-description [html]="lesson()?.active_text?.description_html"></app-carousel-description>
		<app-path-activity-selector [lesson]="lesson()" [activities]="lesson()?.activity!"></app-path-activity-selector>
	</div>
}

@if (!loading() && (!lesson() || !lesson()?.activity || lesson()?.activity!.length === 0)) {
	<h1>No activities available</h1>
}
